// extracted by mini-css-extract-plugin
module.exports = {"text":"NetworkName_text__2oQhU","warning":"NetworkName_warning__20q2G","info":"NetworkName_info__3QA1l","component":"NetworkName_component__1cADZ","icon":"NetworkName_icon__1_6qi"};